export const leaveTypeList = [
  {
    id: '01',
    name: 'Leave'
  },
  {
    id: '02',
    name: 'Permission'
  }
]

export const dayStatusList = [
  {
    id: '01',
    name: 'First Half'
  },
  {
    id: '02',
    name: 'Second Half'
  },
  {
    id: '03',
    name: 'Full day'
  }
]

export const leaveReasonList = [
  {
    id: '01',
    name: 'Sick'
  },
  {
    id: '02',
    name: 'Vacation'
  },
  {
    id: '03',
    name: 'Marriage-Self'
  },
  {
    id: '04',
    name: 'Relative/Friend Marriage'
  },
  {
    id: '05',
    name: 'Out of Station'
  },
  {
    id: '06',
    name: 'Festival'
  },
  {
    id: '07',
    name: 'Ritual'
  },
  {
    id: '08',
    name: 'Family Get Together'
  },
  {
    id: '09',
    name: 'Personal'
  },
  {
    id: '10',
    name: 'Demise in Family'
  },
  {
    id: '11',
    name: 'Others'
  }
]
